import React from "react";
import Modal from "../../component/Inc/Modal";

function PopSelectSubject(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} popSize="xs" type="pop_select_subject">
      <div className="pop_tit line">입금 과목 선택</div>
      <div className="content_container">
        <ul className="chk_list">
          <li>
            <input
              type="radio"
              name="chk"
              id="chk01"
              className="com_chk btn"
            />
            <label htmlFor="chk01">국어</label>
          </li>
          <li>
            <input
              type="radio"
              name="chk"
              id="chk02"
              className="com_chk btn"
            />
            <label htmlFor="chk02">영어</label>
          </li>
          <li>
            <input
              type="radio"
              name="chk"
              id="chk03"
              className="com_chk btn"
            />
            <label htmlFor="chk03">수학</label>
          </li>
          <li>
            <input
              type="radio"
              name="chk"
              id="chk04"
              className="com_chk btn"
            />
            <label htmlFor="chk04">과탐</label>
          </li>
          <li>
            <input
              type="radio"
              name="chk"
              id="chk05"
              className="com_chk btn"
            />
            <label htmlFor="chk05">사탐</label>
          </li>
          <li>
            <input
              type="radio"
              name="chk"
              id="chk06"
              className="com_chk btn"
            />
            <label htmlFor="chk06">논술</label>
          </li>
          <li>
            <input
              type="radio"
              name="chk"
              id="chk07"
              className="com_chk btn"
            />
            <label htmlFor="chk07">면접</label>
          </li>
        </ul>
        
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopSelectSubject;
